import React from "react";
import { Row, Col } from "antd";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import FormHeader from "../../../components/forms/FormHeader";
import { InputItem } from "../../../components/forms/FormItems";
import SwitchItem from "../../../components/forms/SwitchItem";
import { RestrictedSettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import { SelectItem as SelectItemComponent } from "../../../components/forms/FormItems";
import { useSelector } from "react-redux";
import { useSalary_export_types } from "../../../hooks";

const Accounting = () => {
  const details = useSelector((state) => state.organization.settings);
  const salary_export_types = useSalary_export_types();

  const changedValues = useSelector(
    (state) => state.organization.changedItems.values
  );

  const {
    employee_export_type: changedExportType,
    salary_export_type_id: changedSalaryTypeId,
  } = changedValues || {};

  const {
    employee_export_type: detailsExportType,
    salary_export_type_id: detailsSalaryTypeId,
  } = details || {};

  const HARGAL_INTERFACE = "הר-גל ממשק";
  const MICHPAL = "מיכפל";

  const employeeExportType = changedExportType ?? detailsExportType;
  const isHargalInterface = employeeExportType === HARGAL_INTERFACE;

  const salaryExportTypeId = changedSalaryTypeId ?? detailsSalaryTypeId;
  const selectedSalaryExportType = salary_export_types.find(
    (type) => type.id === salaryExportTypeId
  )?.name;
  const isMichpal = selectedSalaryExportType === MICHPAL;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.generalSettings" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="accounting_export_type"
                  category="organization"
                  metadataName={"accounting_export_types"}
                  identfierId="name"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem name="salary_export_id" category="organization" />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="salary_export_type_id"
                  category="organization"
                  metadataName={"salary_export_types"}
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                {isMichpal && (
                  <RestrictedSettingsDataSelect
                    name="half_reported_salary_symbols"
                    category="organization"
                    settingsdataName={"system_tables/salary/salary_symbols"}
                    paramName={"symbol"}
                    mode={"multiple"}
                  />
                )}
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <MetaDataSelect
                  name="employee_export_type"
                  category="organization"
                  metadataName={"employee_export_types"}
                  identfierId="name"
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                {isHargalInterface && (
                  <InputItem
                    name="salary_sync_service_url"
                    category="organization"
                    url={true}
                  />
                )}
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="max_holiday_hours_pay_day"
                  category="organization"
                  number={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="max_vacation_hours_pay_day"
                  category="organization"
                  number={true}
                  precision={2}
                  min={0}
                  max={24}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="min_holiday_salary_seniority"
                  category="organization"
                  number={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SelectItemComponent
                  name="months_between_house_visits"
                  category="organization"
                  houseVisitsMonths={true}
                  allowClear
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem name="ok2go_api_url" category="organization" />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem name="ok2go_password" category="organization" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="time_watch_company_id"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="employee_max_monthly_hours"
                  category="organization"
                  number={true}
                  min={0}
                  max={744}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="zero_transportation_costs_over_75"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="unify_salary_symbols"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="allow_diaries_upfront_approval"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="allow_hours_overloading"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="send_sms_on_finish_house_visit"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="generate_replacement_on_holiday"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RestrictedSettingsDataSelect
                  name="day_center_tariffs"
                  category="organization"
                  settingsdataName={"accounting/client_tariffs"}
                  paramName={"cost"}
                  mode={"multiple"}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RestrictedSettingsDataSelect
                  name="supporting_community_client_tariff_id"
                  category="organization"
                  settingsdataName={"accounting/client_tariffs"}
                  paramName={"cost"}
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="auto_login_days"
                  category="organization"
                  number={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.foreignSettings" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="foreign_pay_extra_hours"
                  category="organization"
                />
              </div>

              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="foreign_pay_holiday_hours"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="foreign_auto_vacation_per_month"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="pay_transportation_costs_to_foreign"
                  category="organization"
                />
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem
                  name="foreign_pay_vacation_hours"
                  category="organization"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default Accounting;
